// Copyright (C) Unite Digital LLC - All Rights Reserved.
// Unauthorized copying of this file, via any medium is strictly prohibited.
// Proprietary and confidential.
// Developed by Unite Digital LLC.

import { Assignees, FieldTypes } from './document.interfaces';

export interface AppEvent {
    context: string;
    data: any;
}

export interface AppEventEx<T> {
    context: string;
    data: T;
}

export interface Dimensions {
    height: number;
    width: number;
}

export interface SuccessMessage {
    content: string;
    title: string;
    btnText?: string;
    autoClose?: boolean;
    displayFullMessage?: boolean;
    richContent?: any;
}

export interface MultiSelectModalComponentProps {
    availableItems: any[];
    existingItems?: any[];
    searchKey: string;
    compareKey?: string;
    returnedKey?: string;
    title?: string;
    description?: string;
    btnText?: string;
    search?: string;
    selectAll?: boolean;
}

export interface EditField {
    assigneeType: Assignees;
    fieldType: FieldTypes;
    label: string;
}

export interface EditSection {
    type: Assignees;
    label: string;
    fields: EditField[];
    isOpen: boolean;
}

export interface FileData {
    base64File: string;
    content: ArrayBuffer;
    contentType: string;
    encoding: string;
    filename: string;
    fieldname: string;
}

export interface NavItem {
    title: string;
    route: string;
    type: RouteType;
    isActive: boolean;
    icon: string;
    accountTypes: string[];
    permissions?: any;
    disabled?: boolean;
    sortOrder?: number;
}

export interface PaginatedData {
    page?: number;
    totalRecords?: number;
}

export enum RouteType {
    Leads,
    ConsumerDocuments,
    Deals,
    ExpressUpload,
    Vehicles,
    Forms,
    Storage,
    DealTypes,
    Help,
    DealerManagement,
    UserManagement,
    Settings,
    Login,
    DocumentLibraryAdmin,
    DocumentLibrary,
    GettingStartedGuide,
    Dashboard,
}

export enum DataType {
    string = 1,
    bool = 2,
    int = 3,
}
